import {Fragment, useEffect, useMemo, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {getDiscountPrice} from "../../helpers/product";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import cogoToast from "cogo-toast";
import SaveThePlanet from "../../components/save-the-planet/saveThePlanet";
import {useTranslation} from "react-i18next";
import {SpeakToExpertButton} from "../../components/SpeakToExpertButton";


const ConfirmationPage = () => {
    const [finalCartTotal, setFinalCartTotal] = useState(0);

    let {pathname} = useLocation();
    const currency = useSelector((state) => state.currency);
    const cartItems = useSelector((state) => state.order.orderData.cartItems);
    const shippingPrice = useSelector((state) => state.order.shippingPrice);

    const navigate = useNavigate();

    const {t} = useTranslation();
    function handleViewDeliveryOptions() {
        navigate(`${process.env.PUBLIC_URL}/control-tower`);
    }

    const computedCartTotalPrice = useMemo(() => {
        let total = 0;
        cartItems.forEach((cartItem) => {
            const discountedPrice = getDiscountPrice(cartItem.price, cartItem.discount);
            const finalProductPrice = (cartItem.price * currency.currencyRate).toFixed(2);
            const finalDiscountedPrice = (discountedPrice * currency.currencyRate).toFixed(2);

            if (discountedPrice !== null) {
                total += finalDiscountedPrice * cartItem.quantity;
            } else {
                total += finalProductPrice * cartItem.quantity;
            }
        });
        return total;
    }, [cartItems, currency.currencyRate]);

    useEffect(() => {
        setFinalCartTotal(computedCartTotalPrice);
    }, [computedCartTotalPrice]);

    return (
        <Fragment>
            <SEO
                titleTemplate="Confirmation"
                description=""
            />
            <LayoutOne headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        {label: t('home'), path: process.env.PUBLIC_URL + "/"},
                        {label: t('checkout'), path: process.env.PUBLIC_URL + pathname}
                    ]}
                />
                <div className="checkout-area pt- pb-100">
                    <div className="container" >
                        {cartItems && cartItems.length >= 1 ? (
                            <div className="row" style={{marginTop: '24px'}}>
                                    <div className="your-order-area">
                                        <h3>{t('order_placed_successfully')}</h3>
                                        <div className="your-order-wrap gray-bg-4">
                                            <div className="your-order-product-info">
                                                <div className="your-order-top">
                                                    <ul>
                                                        <li>{t('product')}</li>
                                                        <li>{t('total_products')}</li>
                                                    </ul>
                                                </div>
                                                <div className="your-order-middle">
                                                    <ul>
                                                        {cartItems.map((cartItem, key) => {
                                                            const discountedPrice = getDiscountPrice(
                                                                cartItem.price,
                                                                cartItem.discount
                                                            );
                                                            const finalProductPrice = (
                                                                cartItem.price * currency.currencyRate
                                                            ).toFixed(2);
                                                            const finalDiscountedPrice = (
                                                                discountedPrice * currency.currencyRate
                                                            ).toFixed(2);


                                                            return (
                                                                <li key={key}>
                                  <span className="order-middle-left">
                                    {cartItem.name} X {cartItem.quantity}
                                  </span>{" "}
                                                                    <span className="order-price">
                                    {discountedPrice !== null
                                        ?
                                        (
                                            finalDiscountedPrice *
                                            cartItem.quantity
                                        ).toFixed(2) + ' ' + currency.currencySymbol
                                        :
                                        (
                                            finalProductPrice * cartItem.quantity
                                        ).toFixed(2) + ' ' + currency.currencySymbol
                                        }
                                  </span>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                                {shippingPrice > 0 ?
                                                    <div className="your-order-bottom">
                                                        <ul>
                                                            <li className="your-order-shipping">Shipping</li>
                                                            <li>${shippingPrice + ' ' + currency.currencySymbol}</li>
                                                        </ul>
                                                    </div> : null}
                                                <div className="your-order-total">
                                                    <ul>
                                                        <li className="order-total">{t('grand_total')}</li>
                                                        <li>
                                                            ${(finalCartTotal + shippingPrice).toFixed(2) + ' ' + currency.currencySymbol}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <SaveThePlanet />
                                                <div className="delivery-options mt-20">
                                                    <button className="btn-hover" onClick={handleViewDeliveryOptions}>{t('go_to_control_tower')}
                                                    </button>
                                                    <SpeakToExpertButton />
                                                </div>
                                            </div>
                                            <div className="payment-method"></div>
                                        </div>
                                        <div className="place-order mt-25">
                                        </div>
                                    </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item-empty-area text-center">
                                        <div className="item-empty-area__icon mb-30">
                                            <i className="pe-7s-cash"></i>
                                        </div>
                                        <div className="item-empty-area__text">
                                            No items found in cart to checkout <br/>{" "}
                                            <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
                                                Shop Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </LayoutOne>

        </Fragment>
    );
};

export default ConfirmationPage;
